import useDesktopObservation from './useDesktopObservation';
import { validMediaReadinessStatus } from '@/utils/mediaReadinessPresentation';

export default function useMediaReadinessStatus() {
  const observation = useDesktopObservation('getMediaReadinessStatus', 'onMediaReadinessStatusChanged', {
    validate: validMediaReadinessStatus,
  });
  return { ...observation, desktopAvailable: observation.available };
}
